import {Injectable} from '@angular/core';
import { callFxRates } from '@cbcore/NGRX/configuration/configuration.actions';
import { AppState, callCoreSettings } from '@cbcore/NGRX/core.state';
import { selectMenuLoaded } from '@cbcore/NGRX/pool/pool.selectors';
import { TranslationService} from "@cbcore/services/translation/translation.service";
import { Store } from '@ngrx/store';
import { combineLatest } from 'rxjs';

@Injectable()
export class AppConfig {
  constructor(
    public translationService: TranslationService,
    private store: Store<AppState>,  
  ) {
  }

  loadInitialData(): any {
    const langaugeLoaded$ = this.translationService.ready();

    const menuLoaded$ = this.store.select(selectMenuLoaded);

    const selectionsCombined$ = combineLatest([langaugeLoaded$, menuLoaded$]);

    this.store.dispatch(callFxRates());
    this.store.dispatch(callCoreSettings());


    return new Promise((resolve, _reject) => {
      this.translationService.onInit();
      selectionsCombined$.subscribe(([language, menu]) => {
        if (menu && language) {
          resolve(true);
        }
      }, _error => {
        resolve(true);
      })
    })
  }
}
